import { ButtonIcon, Icons, Typography } from 'components';
import styled from 'styled-components';

import { default as Box } from 'components/flex/Box';
import { default as Flex } from 'components/flex/Flex';

export const TableThead = styled('thead')``;
export const TableTbody = styled('tbody')``;
export const TableTd = styled('td')``;
export const TableTh = styled('th')``;
export const TableTr = styled('tr')`
  background: ${(props: any) => (props['data-selected'] ? props.theme.colors.gray_100 : 'white')};

  ${TableTh} {
    background: ${(props: any) => (props['data-selected'] ? props.theme.colors.gray_100 : 'white')};
  }
`;

export const TableRowActions = styled(Flex)`
  display: none;
  position: absolute;
  height: 100%;
  align-items: center;
  right: 0;
  background: ${({ theme }) => theme.colors.gray_100};
  margin-right: ${(props: any) => (props['data-actions'] ? '33px' : '15px')};
  box-shadow: -9px 0px 10px 0px ${({ theme }) => theme.colors.gray_100};
  padding-left: 10px;
  padding-right: 5px;
`;

export const TableWrapper = styled.div`
  max-width: 100%;

  scrollbar-width: thin;
  /* scrollbar-color: blue orange; */

  /* Works on Chrome, Edge, and Safari */
  &::-webkit-scrollbar {
    height: 10px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.gray_300};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.gray_600};
    border: 2px solid ${({ theme }) => theme.colors.gray_300};
    border-radius: 10px;
  }
`;

export const Table = styled('table')`
  white-space: nowrap;
  margin-top: 0px;
  border: none;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  min-width: 100%;

  ${TableThead} {
    ${TableTh} {
      text-align: left;
      position: sticky;
      z-index: 1;
      background: ${({ theme }) => theme.colors.dark_350};
      color: ${({ theme }) => theme.colors.gray_500};
      ${({ theme }) => theme.fontTypes.type2}
      font-weight: ${({ theme }) => theme.fontWeights.regular};
      text-transform: uppercase;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 30px;

      &:first-child {
        position: sticky;
        left: 0;
        z-index: 2;
        padding-left: 0px;
      }

      &:last-child {
        padding-right: 30px;
      }
    }
  }

  ${TableTbody} {
    ${TableTh} {
      text-align: left;
      position: relative;
      box-shadow: 1px 0px 15px 5px rgba(0, 0, 0, 0.35);
      clip-path: inset(0px -30px 0px 0px);
      border-bottom: 1px solid ${({ theme }) => theme.colors.gray_300};
      position: sticky;
      left: 0;
      z-index: 1;
      padding-top: 15px;
      padding-bottom: 15px;
    }

    ${TableTr} {
      &:hover {
        ${TableTh}, ${TableTd} {
          background: ${({ theme }) => theme.colors.gray_100};
        }

        ${TableRowActions} {
          display: flex;
        }
      }
    }
  }

  ${TableTd} {
    text-align: left;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray_300};
    padding-left: 30px;
    padding-top: 15px;
    padding-bottom: 15px;

    &[data-tags] {
      padding-left: 30px;
    }

    &:last-child {
      padding-right: 30px;
    }
  }
`;

export const OrderIcon = styled(Icons)`
  width: 29px;
  color: ${(props: any) => (props['data-active'] ? props.theme.colors.primary_400 : props.theme.colors.white30)};
`;

export const OrderIconWrapper = styled.i`
  width: 12px;
  height: 8px;
  position: relative;
  overflow: hidden;
  margin-left: 7px;

  ${OrderIcon} {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const Tag = styled('i')`
  display: inlin-block;
  font-style: normal;
  color: white;
  ${({ theme }) => theme.fontTypes.type0}
  font-weight: 700;
  padding: 0px 6px;
  border-radius: 2px;
  text-transform: uppercase;

  ${(props: any) => {
    switch (props['data-type']) {
      case 'pg':
        return `
            background: #00BFBE;
        `;

      case 'lp':
        return `
                background: #F4BC04;
            `;

      case 'cv':
        return `
            background: #007BBF;
        `;

      case 'bq':
        return `
            background: #CF0000;
        `;

      case 'cf':
        return `
            background: #2A2C2B;
        `;
    }
  }}
`;

export const CustomButtonIcon = styled(ButtonIcon)``;

export const ButtonGroup = styled(Flex)`
  border: 2px solid ${({ theme }) => theme.colors.gray_200};
  border-radius: 4px;

  &:first-child {
    ${CustomButtonIcon} {
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
    }
  }

  &:last-child {
    ${CustomButtonIcon} {
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }
  }
`;

export const TableTags = styled(Flex)`
  ${Tag} {
    margin-left: 2px;
  }
`;

export const FlexParent = styled('div')`
  display: flex;
  align-items: center;
`;

export const LongAndTruncated = styled(Typography)`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: text;
`;

export const ShortAndFixed = styled('div')`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding-right: 10px;
`;

export const FilterValue = styled(Typography)``;

//
export const FilterBox = styled(Box)`
  cursor: pointer;

  opacity: ${(props: any) => (props['data-hasfilter'] ? (props['data-isfilter'] ? '1' : '0.5') : '1')};

  ${FilterValue} {
    color: ${(props: any) =>
      props['data-hasfilter']
        ? props['data-isfilter']
          ? props.theme.colors.primary_400
          : props.theme.colors.gray_600
        : props.theme.colors.gray_600};
  }

  &:hover {
    opacity: 1;

    ${FilterValue} {
      color: ${({ theme }) => theme.colors.primary_400};
    }
  }
`;

export const SearchButtonIcon = styled(ButtonIcon)``;
